import { render, staticRenderFns } from "./ReportInfo.vue?vue&type=template&id=8a6c4404&scoped=true&"
import script from "./ReportInfo.vue?vue&type=script&lang=js&"
export * from "./ReportInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReportInfo.vue?vue&type=style&index=0&id=8a6c4404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6c4404",
  null
  
)

export default component.exports